<button class="btn btn-lg btn-secondary btn-animated" (click)="open()">
  <span>Launch demo modal</span>
</button>
